module.exports = __webpack_public_path__ + "img/ADB.a749b415.png";